import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const Background = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 0.25rem 0;

  background: black;
`;

// prettier ignore is needed cuz otherwise prettier breaks into three lines and styled components can't read other styles
export const LogoWrapper = styled.div`
  /* prettier-ignore */
  width: calc(100% + 2rem); // 2rem because when fragment is rendered with layout it has padding 16px for X axis
  left: -1rem;
  position: relative;
  margin-bottom: 0.5rem;

  @media (min-width: ${breakpoints.lg}) {
    left: 0;
    width: 100%;
    margin-bottom: 0;
  }
`;

export const Spacer = styled.div`
  display: none;
  height: 2rem;
  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;
